import { render, staticRenderFns } from "./product-seat.vue?vue&type=template&id=09be3338&"
import script from "./product-seat.vue?vue&type=script&lang=js&"
export * from "./product-seat.vue?vue&type=script&lang=js&"
import style0 from "./product-seat.vue?vue&type=style&index=0&id=09be3338&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports